import { render, staticRenderFns } from "./ContractHistory.vue?vue&type=template&id=24e8d6d0&"
import script from "./ContractHistory.vue?vue&type=script&lang=ts&"
export * from "./ContractHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports